import React, { FC, useState } from 'react'
import { IonModal, IonContent, IonFooter, IonSlides, IonSlide } from '@ionic/react'
import { cartMobx, discountMobx } from 'mobx/mall'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import CouponList from './CouponList'
import { observer } from 'mobx-react'
import { ModalHeader } from '@cps'
import SingleCouponsModal from '../SingleCouponsModal'
import { get } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  reject?: any;
  resolve?: any;
  tabsType?: string;
}

const CounponModal: FC<IProps> = ({ tabsType, reject = () => { }, resolve = () => {} }) => {
  const counponType = ['single', 'all', tabsType !== 'noPromoCode' && 'promoCode'].filter(Boolean)
  // const counponType = ['single', 'all', 'promoCode'].filter(Boolean)

  const [curSlide, setCurSlide] = useState(0)
  // const [modalPromoCodeCoupons, setModalPromoCodeCoupons] = useState(discountMobx.promoCodeCoupons)
  const slideOpts = {
    initialSlide: curSlide,
    speed: 400
  }

  return (
    <IonModal
      isOpen
      cssClass='mall-coupon-modal tall-modal'
      onDidPresent={() => {
        (document.getElementById('couponSlider') as any)?.update?.()
      }}
    >
      <ModalHeader title={i18n.t('cart.chooseCoupon')} onClose={reject} />
      <IonContent scrollX={false} scrollY={false}>
        <div className='coupon-content-box'>
          <div className='coupon-type-wrap'>
            <div className='coupon-type-list'>
              {
                counponType.map((type: string, index: number) => {
                  return (
                    <div
                      key={type}
                      className={`coupon-type-item${index === curSlide ? ' choosed' : ''}`}
                      onClick={() => {
                        if (curSlide !== index) {
                          (document.getElementById('couponSlider') as any).slideTo(index, 0)
                        }
                      }}
                    >
                      {type === 'promoCode' ? i18n.t('cart.promoCode') : i18n.t(`cart.${type}Coupon`)}
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='coupon-sliders'>
            <IonSlides
              id='couponSlider'
              onIonSlideDidChange={(e: any) => {
                setCurSlide(e.target.swiper.activeIndex)
              }}
              options={slideOpts}
            >
              <IonSlide>
                <CouponList
                  coupons={Object.values(discountMobx.discountResult.memberItemCouponMap)}
                  isSingle={curSlide === 0}
                  selectItemCouponMap={discountMobx.discountAction.selectItemCouponMap}
                  onUseClick={(coupon) => {
                    const currentSelectPK = get(discountMobx.discountAction.selectItemCouponMap, `${coupon?.memberCouponId}`)
                    const canSelectPK = get(coupon.canUseProductPk, '0')
                    if (coupon.canUseProductPk?.length > 1) {
                      modalLayer(SingleCouponsModal, { data: coupon }, 'SingleCouponsModal')
                        .then(() => { })
                        .catch(() => { })
                    } else if (coupon.canUseProductPk?.length === 1) {
                      discountMobx.selectSingleProductCoupon((currentSelectPK === canSelectPK) ? (`${coupon?.memberCouponId}`) : { [coupon?.memberCouponId as number]: canSelectPK }, coupon.status === 'mutex')
                      // discountMobx.selectSingleProductCoupon((currentSelectPK === canSelectPK) ? (`${coupon?.memberCouponId}`) : { ...discountMobx.discountAction.selectItemCouponMap, [coupon?.memberCouponId as number]: canSelectPK })
                    }
                  }}
                />
              </IonSlide>
              <IonSlide>
                <CouponList
                  coupons={Object.values(discountMobx.wholeCoupons)}
                  onUseClick={(coupon) => discountMobx.selectCoupon(coupon)}
                />
              </IonSlide>
              {/* <IonSlide>
                <CouponList
                  coupons={discountMobx.promoCodeCoupons.map(coupon => {
                    if (coupon.status === 'disable') {
                      return { ...coupon, reason: i18n.t('checkout.promocode_not_optimal') }
                    }
                    return coupon
                  })}
                  isDelete
                  isPromoCode
                  onUseClick={(coupon) => {
                    confirmLayer({
                      children: i18n.t('common.confrim_whether_cancel')
                    }).then(() => {
                      const exitCodes = discountMobx.discountAction.promoCodes
                      discountMobx.setPromoCodes(exitCodes.filter(v => v !== coupon.promoCode))
                    }, () => {})
                    // discountMobx.selectPromoCode(coupon.promoCode)
                    // // 处理页面的选中
                    // setModalPromoCodeCoupons(modalPromoCodeCoupons.map(promoCodeCoupon => {
                    //   return {
                    //     ...promoCodeCoupon,
                    //     isSelect: discountMobx.discountAction.promoCodes.includes(promoCodeCoupon.promoCode)
                    //   }
                    // }))
                  }}
                />
              </IonSlide> */}
            </IonSlides>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='coupon-footer'>
          <div className='coupon-price'>
            <p>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedCouponCnt })}</p>
            <p>{i18n.t('cart.discount')}{format.toPrice(cartMobx.cartResult.discountCouponPrice + cartMobx.cartResult.discountItemCouponPrice)}</p>
          </div>
          <div className='certain-btn' onClick={() => resolve()}>{i18n.t('common.ok')}</div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CounponModal)
